import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SgiInformacaoDocumentada, SgiInformacaoDocumentadaCreate, SgiInformacaoDocumentadaHistorico, SgiInformacaoDocumentadaKpi, SgiDocumentosPendentesUsuario, SgiInformacaoDocumentadaSolicitacaoRevisaoRequest, SgiInformacaoDocumentadaSolicitacaoRevisao } from 'src/app/shared/interfaces/sgi-informacao-documentada/sgi-informacao-documentada.interface';
import { PageItem } from 'src/app/shared/interfaces/page-item.interface';

@Injectable({
  providedIn: 'root'
})
export class SgiInformacaoDocumentadaAPIService {

  private baseUrl = `${environment.APIEndpoint}sgi-informacao-documentada`;

  constructor(private http: HttpClient) {}

  getAll(
    pageNumber: number = 1,
    pageSize: number = 11,
    titulo: string = '',
    codigoReferencia: string = '',
    processo: string = '',
    tipoInformacao: string = '',
    origem: string = '',
    autorOrgaoEmissor: string = '',
    responsavelAprovacaoId: number | null = null,
    vigenciaInicio: string = '',
    vigenciaFim: string = '',
    autorOrgaoEmissorId: number | null = null,
    usuarioAutorId: number | null = null,
    orderBy: string = '',
    orderDirection: string = 'asc'
  ): Observable<PageItem> {
    let params = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;

    if (titulo)                         params += `&titulo=${titulo}`;
    if (codigoReferencia)               params += `&codigoReferencia=${codigoReferencia}`;
    if (processo)                       params += `&processo=${processo}`;
    if (tipoInformacao)                 params += `&tipoInformacao=${tipoInformacao}`;
    if (origem)                         params += `&origem=${origem}`;
    if (autorOrgaoEmissor)              params += `&autorOrgaoEmissor=${autorOrgaoEmissor}`;
    if (responsavelAprovacaoId != null) params += `&responsavelAprovacaoId=${responsavelAprovacaoId}`;
    if (vigenciaInicio)                 params += `&vigenciaInicio=${vigenciaInicio}`;
    if (vigenciaFim)                    params += `&vigenciaFim=${vigenciaFim}`;
    if (autorOrgaoEmissorId != null)    params += `&autorOrgaoEmissorId=${autorOrgaoEmissorId}`;
    if (usuarioAutorId != null)         params += `&usuarioAutorId=${usuarioAutorId}`;
    if (orderBy)                        params += `&orderBy=${orderBy}&orderDirection=${orderDirection}`;

    return this.http.get<PageItem>(this.baseUrl + params);
  }

  getById(id: number): Observable<SgiInformacaoDocumentada> {
    return this.http.get<SgiInformacaoDocumentada>(`${this.baseUrl}/${id}`);
  }

  create(data: SgiInformacaoDocumentadaCreate): Observable<any> {
    return this.http.post(this.baseUrl, data);
  }

  update(id: number, data: SgiInformacaoDocumentadaCreate): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, data);
  }

  getHistorico(id: number): Observable<SgiInformacaoDocumentadaHistorico[]> {
    return this.http.get<SgiInformacaoDocumentadaHistorico[]>(`${this.baseUrl}/${id}/historico`);
  }

  getKpis(): Observable<SgiInformacaoDocumentadaKpi> {
    return this.http.get<SgiInformacaoDocumentadaKpi>(`${this.baseUrl}/kpis`);
  }

  getDocumentosPendentes(usuarioId: number): Observable<SgiDocumentosPendentesUsuario> {
    return this.http.get<SgiDocumentosPendentesUsuario>(`${this.baseUrl}/pendentes-usuario/${usuarioId}`);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  enviarSolicitacaoRevisao(request: SgiInformacaoDocumentadaSolicitacaoRevisaoRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}/solicitacao-revisao`, request);
  }

  getSolicitacoesRevisaoPendentes(): Observable<SgiInformacaoDocumentadaSolicitacaoRevisao[]> {
    return this.http.get<SgiInformacaoDocumentadaSolicitacaoRevisao[]>(`${this.baseUrl}/solicitacao-revisao/pendentes`);
  }

  getSolicitacaoRevisaoPorId(id: number): Observable<SgiInformacaoDocumentadaSolicitacaoRevisao> {
    return this.http.get<SgiInformacaoDocumentadaSolicitacaoRevisao>(`${this.baseUrl}/solicitacao-revisao/${id}`);
  }

  aprovarSolicitacaoRevisao(documentoId: number, solicitacaoId: number, payload: SgiInformacaoDocumentadaCreate): Observable<any> {
    return this.http.put(`${this.baseUrl}/${documentoId}/solicitacao-revisao/${solicitacaoId}/aprovar`, { ...payload, solicitacaoId });
  }

  reprovarSolicitacaoRevisao(solicitacaoId: number, motivoReprovacao: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/solicitacao-revisao/${solicitacaoId}/reprovar`, { solicitacaoId, motivoReprovacao });
  }

  getHistoricoTramitacao(documentoId: number): Observable<SgiInformacaoDocumentadaSolicitacaoRevisao[]> {
    return this.http.get<SgiInformacaoDocumentadaSolicitacaoRevisao[]>(`${this.baseUrl}/${documentoId}/historico-tramitacao`);
  }

  getDocumentacao(documentoId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/${documentoId}/documentacao`);
  }

  exportarExcel(
    titulo: string = '',
    codigoReferencia: string = '',
    processo: string = '',
    tipoInformacao: string = '',
    origem: string = '',
    autorOrgaoEmissor: string = '',
    responsavelAprovacaoId: number | null = null,
    vigenciaInicio: string = '',
    vigenciaFim: string = '',
    autorOrgaoEmissorId: number | null = null,
    usuarioAutorId: number | null = null,
    orderBy: string = '',
    orderDirection: string = 'asc'
  ): Observable<any> {
    let params = `?`;

    if (titulo)                         params += `&titulo=${titulo}`;
    if (codigoReferencia)               params += `&codigoReferencia=${codigoReferencia}`;
    if (processo)                       params += `&processo=${processo}`;
    if (tipoInformacao)                 params += `&tipoInformacao=${tipoInformacao}`;
    if (origem)                         params += `&origem=${origem}`;
    if (autorOrgaoEmissor)              params += `&autorOrgaoEmissor=${autorOrgaoEmissor}`;
    if (responsavelAprovacaoId != null) params += `&responsavelAprovacaoId=${responsavelAprovacaoId}`;
    if (vigenciaInicio)                 params += `&vigenciaInicio=${vigenciaInicio}`;
    if (vigenciaFim)                    params += `&vigenciaFim=${vigenciaFim}`;
    if (autorOrgaoEmissorId != null)    params += `&autorOrgaoEmissorId=${autorOrgaoEmissorId}`;
    if (usuarioAutorId != null)         params += `&usuarioAutorId=${usuarioAutorId}`;
    if (orderBy)                        params += `&orderBy=${orderBy}&orderDirection=${orderDirection}`;

    return this.http.get(`${this.baseUrl}/exportar-excel${params}`);
  }
}
